import styled from 'styled-components';
import UserListCard from '../Components/UserListCard';
import InfiniteScroll from 'react-infinite-scroll-component';
import classNames from 'classnames';
import ArrowUpIcon from 'assets/svgs/ArrowUpIcon';
import ArrowDownIcon from 'assets/svgs/ArrowDownIcon';
import { IFormAudience, ISortOrderFormAudience } from '../interfaces';
import { TableHeadingFormAudience } from '../constants';
import SummarySubmissionHeaderSkeleton from '../Components/FormSummarySubmissionHeaderSkeleton';
import FormSummaryListingSkeleton from '../Components/FormSummaryLisitngSkeleton';
interface IUserListingSectionProps {
  contacts: IFormAudience[];
  sortOrder: ISortOrderFormAudience;
  loadMore: () => void;
  handleSortClick: (currentSortOrder: keyof ISortOrderFormAudience, sortContactBy: string, sortContactType: string) => void;
  activeSearchFilter: boolean;
  loading: boolean;
  searchTerm: string;
}
const commonCSS = {
  color: '#5e7079',
  margin: 0,
  fontFamily: 'Roboto',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '17.996px',
};

const UserListingWrapper = styled.div`
  width: 100%;
  height: 324px;
  border-radius: 7.597px;
  position: relative;
  background: #fff;
  box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
  padding-top: 20px;

  .aud-Infinite-scroll {
    overflow-y: auto;
    overflow-x: hidden !important;
    height: auto !important;
    max-height: 270px !important;
    padding: 0 11px 12px 16px !important;
  }

  .no-data-found {
    position: absolute;
    margin: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: 500;
    font-size: 24px;
    line-height: 20px;
    font-family: 'Roboto Slab';
    color: #424b50;
  }
`;

const UserListHeader = styled.div`
  display: grid;
  grid-template-columns: 1.5fr repeat(5, 1fr); /* Adjust the column widths as needed */
  align-items: center;
`;

const HeaderColumn = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${commonCSS};
  @media all and (max-width: 1152px) {
    .column-name-text {
      font-size: 13px !important;
    }
    .column-company-text {
      font-size: 13px !important;
    }
    .column-personality-text {
      font-size: 13px !important;
    }
    .column-conversion-text {
      font-size: 13px !important;
    }
    .column-submitted-text {
      font-size: 13px !important;
    }
  }

  .header-company-name {
    @media all and (max-width: 1080px) {
      padding-left: 0px;
    }
  }
`;

const UserListingSection = (props: IUserListingSectionProps) => {
  const { contacts, loadMore, handleSortClick, sortOrder, activeSearchFilter, loading, searchTerm } = props;
  const skeletonArray = Array.from({ length: 2 }).map((_, index) => <FormSummaryListingSkeleton />);

  const convertSortOrder = (sortType: string) => {
    if (sortType === 'ascend') return 'DESC';
    return 'ASC';
  };
  return (
    <>
      <UserListingWrapper className="form-summary-submission-section">
        {contacts.length > 0 ? (
          <UserListHeader style={{ padding: '0 16px' }}>
            <HeaderColumn
              style={{ gridColumn: '1' }}
              onClick={() => {
                handleSortClick(
                  TableHeadingFormAudience.NAME.toLowerCase() as keyof ISortOrderFormAudience,
                  TableHeadingFormAudience.NAME,
                  convertSortOrder(sortOrder.full_name as string),
                );
              }}
            >
              <span className="column-name-text" style={{ display: 'flex', alignItems: 'center', paddingLeft: '86px' }}>
                Name
                <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: 2, paddingLeft: '8px' }}>
                  <ArrowUpIcon disabled={sortOrder.full_name !== 'ascend'} />
                  <ArrowDownIcon disabled={sortOrder.full_name !== 'descend'} />
                </span>
              </span>
            </HeaderColumn>
            {/* Repeat for other columns */}
            <HeaderColumn
              onClick={() => {
                handleSortClick(
                  TableHeadingFormAudience.COMPANY.toLowerCase() as keyof ISortOrderFormAudience,
                  TableHeadingFormAudience.COMPANY,
                  convertSortOrder(sortOrder.company_name as string),
                );
              }}
              className="header-company-name"
            >
              <span className="column-company-text">Company</span>
              <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: 2, paddingLeft: '8px' }}>
                <ArrowUpIcon disabled={sortOrder.company_name !== 'ascend'} />
                <ArrowDownIcon disabled={sortOrder.company_name !== 'descend'} />
              </span>
            </HeaderColumn>
            <HeaderColumn
              onClick={() => {
                handleSortClick(
                  TableHeadingFormAudience.PERSONALITY.toLowerCase() as keyof ISortOrderFormAudience,
                  TableHeadingFormAudience.PERSONALITY,
                  convertSortOrder(sortOrder.personality_name as string),
                );
              }}
            >
              <span className="column-personality-text">Personality</span>
              <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: 2, paddingLeft: '8px' }}>
                <ArrowUpIcon disabled={sortOrder.personality_name !== 'ascend'} />
                <ArrowDownIcon disabled={sortOrder.personality_name !== 'descend'} />
              </span>
            </HeaderColumn>
            <HeaderColumn
              onClick={() => {
                handleSortClick(
                  TableHeadingFormAudience.ORIGIN_DOMAIN.toLowerCase() as keyof ISortOrderFormAudience,
                  TableHeadingFormAudience.ORIGIN_DOMAIN,
                  convertSortOrder(sortOrder.origin_domain as string),
                );
              }}
            >
              <span className="column-conversion-text">Conversion Page</span>
              <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: 2, paddingLeft: '8px' }}>
                <ArrowUpIcon disabled={sortOrder.origin_domain !== 'ascend'} />
                <ArrowDownIcon disabled={sortOrder.origin_domain !== 'descend'} />
              </span>
            </HeaderColumn>
            <HeaderColumn
              onClick={() => {
                handleSortClick(
                  TableHeadingFormAudience.Submitted.toLowerCase() as keyof ISortOrderFormAudience,
                  TableHeadingFormAudience.Submitted,
                  convertSortOrder(sortOrder.created_on as string),
                );
              }}
            >
              <span className="column-submitted-text">Submitted at</span>
              <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: 2, paddingLeft: '8px' }}>
                <ArrowUpIcon disabled={sortOrder.created_on !== 'ascend'} />
                <ArrowDownIcon disabled={sortOrder.created_on !== 'descend'} />
              </span>
            </HeaderColumn>
            <HeaderColumn>{/* Empty column */}</HeaderColumn>
          </UserListHeader>
        ) : null}
        <InfiniteScroll
          dataLength={contacts.length + 1}
          next={loadMore}
          hasMore
          loader={false}
          className={classNames('aud-Infinite-scroll', { loadingFlag: 'loading' })}
          height="250px"
        >
          {contacts.map((user, index) => (
            <UserListCard key={index} user={user} />
          ))}
          {contacts.length === 0 && !loading && searchTerm.length === 0 ? (
            <p className="no-data-found">{'No submission(s) found'}</p>
          ) : contacts.length === 0 && searchTerm.length > 0 && !loading ? (
            <p className="no-data-found">{'No submission(s) found against your search'}</p>
          ) : null}
          {loading ? (
            <>
              {loading && contacts.length === 0 ? <SummarySubmissionHeaderSkeleton /> : null}
              {skeletonArray}
            </>
          ) : null}
        </InfiniteScroll>
      </UserListingWrapper>
    </>
  );
};

export default UserListingSection;
